import { style, styleVariants } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { vars } from "plos/src/styles/theme.css";

export const crestPlaceholderStyles = recipe({
  base: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: vars.space.xs,
    borderRadius: vars.radii.m,
  },
  variants: {
    size: {
      sm: { padding: vars.space.s },
      lg: { padding: vars.space.xl },
    },
    status: {
      add: {
        backgroundColor: vars.colors.surfaceVariant,
      },
      pending: {
        background: `linear-gradient(90deg, ${vars.colors.plBlue} 0%, #6877ff 100%)`,

        color: vars.colors.primaryFixed,
      },
    },
  },
  defaultVariants: {
    size: "sm",
    status: "add",
  },
});

const basePlaceholderIconStyles = style({
  fill: "currentColor",
});

export const crestPlaceholderIcon = styleVariants({
  sm: [
    basePlaceholderIconStyles,
    {
      width: 76,
      height: 90,
    },
  ],
  lg: [
    basePlaceholderIconStyles,
    {
      width: 178,
      height: 208,
    },
  ],
});

const textBase = style({
  textAlign: "center",
  lineHeight: 1,
  letterSpacing: "-0.06em",
  fontFamily: vars.fonts.bold,
});

export const crestPlaceholderText = styleVariants({
  sm: [textBase, { fontSize: vars.fontSizes.body.xl }],
  lg: [textBase, { fontSize: "4rem" }],
});
